import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES, CONTACT } from "@/data/content";

export const Services = () => (
    <section id="services" className="py-20 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
            <Reveal>
                <div className="flex items-center gap-4">
                    <span className="font-mono text-sm text-terra">02</span>
                    <span className="h-px w-10 bg-terra/50" />
                    <span className="text-xs uppercase tracking-[0.25em] text-timber">What We Do</span>
                </div>
                <h2 className="mt-6 max-w-2xl font-serif text-2xl font-normal leading-snug tracking-tight text-ink sm:text-3xl lg:text-4xl">
                    Comprehensive, End-to-End Solutions
                </h2>
            </Reveal>
            <div className="mt-14 border-t border-wood/10">
                {SERVICES.map((s, i) => (
                    <Reveal key={s.id} delay={0.04 * i} y={16}>
                        <a
                            href={CONTACT.whatsappHref}
                            target="_blank"
                            rel="noreferrer"
                            data-testid={`service-card-${s.id}`}
                            className="group grid grid-cols-12 items-center gap-4 border-b border-wood/10 py-7 transition-colors duration-500 hover:bg-sand md:px-6 lg:py-9"
                        >
                            <span className="col-span-2 font-mono text-xs text-terra sm:col-span-1">{s.number}</span>
                            <h3 className="col-span-9 font-serif text-lg font-medium leading-snug text-ink transition-transform duration-500 group-hover:translate-x-2 sm:col-span-4 sm:text-xl lg:text-2xl">
                                {s.title}
                            </h3>
                            <p className="col-span-10 col-start-3 text-sm font-light leading-relaxed text-mute sm:col-span-6 sm:col-start-6">
                                {s.text}
                            </p>
                            <span className="col-span-1 hidden justify-self-end text-wood/40 transition-all duration-500 group-hover:translate-x-1 group-hover:text-terra sm:block">
                                <ArrowUpRight size={20} strokeWidth={1.5} />
                            </span>
                        </a>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
